function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 249 119"
}, props), React.createElement("path", {
  d: "M195 5.5a1 1 0 00-1-1H23.15a1 1 0 00-1 1V101.421a1 1 0 001 1H194a1 1 0 001-1V5.5z",
  fill: "#fff",
  stroke: "#B8B7B7",
  strokeWidth: "8"
}), React.createElement("path", {
  d: "M237.388 1.899c-.075-.76-1.153-.839-1.338-.098a.68.68 0 00.018.392l.274.774c.783 2.218-.862 4.544-3.214 4.544H131.5l-97.887 2.8a7 7 0 00-6.797 6.803L24.2 111.306a7 7 0 006.997 7.194h210.071c4.14 0 7.376-3.574 6.966-7.694L237.388 1.899z",
  fill: "#fff"
}), React.createElement("path", {
  d: "M40.04 86.085a4.84 4.84 0 01-.248 6.198l-12.997 14.364c-3.109 3.436-8.478 3.52-11.693.183L7.076 98.5l-5.18-6.375a4.673 4.673 0 016.986-6.196l6.236 6.444c3.212 3.32 8.558 3.237 11.667-.179l5.837-6.416a4.84 4.84 0 017.418.307z",
  fill: "#B8B7B7"
})));